<div class="map-line-chart-card" *ngIf="resolvedData || isAdmin">
    <div class="chart-header">
        <div class="chart-header__meta">
            <p class="chart-title">{{ chartTitle }}</p>
            <small class="chart-subtitle">{{ chartDescription }}</small>
            <!-- <div class="chart-tags" *ngIf="chartLabels?.length">
                <span class="chart-tag" *ngFor="let label of chartLabels">{{ label }}</span>
            </div> -->
        </div>
        <div class="chart-header__actions" *ngIf="isAdmin">
            <button type="button" class="btn btn-outline-danger btn-sm chart-create-btn" *ngIf="activeChartId"
                (click)="deleteChart()">
                <i class="fa-solid fa-trash"></i>
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm chart-create-btn" *ngIf="activeChartId"
                (click)="openCreateDataModal('edit')">
                <i class="fa-solid fa-pen"></i>
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm chart-create-btn"
                (click)="openCreateDataModal('create')">
                <i class="fa-solid fa-plus"></i>
            </button>
        </div>
    </div>
    <div class="chart-canvas-wrapper" [ngClass]="{
        'chart-flip-active': flipAnimating,
        'chart-flip-next': flipAnimating && flipDirection === 'next',
        'chart-flip-prev': flipAnimating && flipDirection === 'prev'
    }">
        <div class="chart-empty-state" *ngIf="hasNoData">
            <i class="fa-solid fa-chart-line"></i>
            <p>No chart data found</p>
        </div>
        <div class="chart-canvas-stage" *ngIf="!hasNoData">
            <canvas #chartCanvas aria-label="Monthly visitors and replies chart" role="img"></canvas>
        </div>
    </div>
    <div class="chart-nav-controls" *ngIf="chartRecords.length > 1">
        <button type="button" class="chart-nav-arrow chart-nav-arrow--left" (click)="switchChart('prev')"
            [disabled]="flipAnimating || activeChartIndex === 0" aria-label="Previous chart">
            <i class="fa-solid fa-chevron-left"></i>
        </button>
        <button type="button" class="chart-nav-arrow chart-nav-arrow--right" (click)="switchChart('next')"
            [disabled]="flipAnimating || activeChartIndex >= chartRecords.length - 1" aria-label="Next chart">
            <i class="fa-solid fa-chevron-right"></i>
        </button>
    </div>
</div>

<ng-template #createDataModal>
    <div class="show-booking-modal chart-data-modal">
        <div class="show-booking-modal__header">
            <h5 class="show-booking-modal__title">
                <i class="fa-solid fa-chart-line mr-2"></i>
                Create Chart Data
            </h5>
            <button type="button" class="show-booking-modal__close" (click)="closeCreateDataModal()">
                <i class="fa-solid fa-times"></i>
            </button>
        </div>
        <div class="show-booking-modal__body">
            <div class="chart-data-form">
                <div class="chart-data-form__meta row gx-2 gy-2">
                    <div class="col-12 col-md-6">
                        <div class="form-floating">
                            <label class="mb-0">Chart Title</label>
                            <input type="text" class="form-control" [(ngModel)]="editableTitle" name="chartTitle"
                                placeholder="Chart Title" />
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-floating">
                            <label class="mb-0 mt-2">Description</label>
                            <textarea class="form-control" rows="2" [(ngModel)]="editableDescription"
                                name="chartDescription" placeholder="Chart description"></textarea>
                        </div>
                    </div>
                </div>
                <div class="chart-tags-editor">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <p class="intro-title mb-0">
                            <i class="fa-solid fa-tags mr-2"></i>Add Labels
                        </p>
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="addMetaLabel()">
                            <i class="fa-solid fa-plus mr-1"></i>Add Label
                        </button>
                    </div>
                    <div class="row gx-2 gy-2 mb-3">
                        <div class="col-12 col-md-6 col-lg-4"
                            *ngFor="let label of editableLabels; let idx = index; trackBy: trackByIndex">
                            <div class="input-group">
                                <input type="text" class="form-control" [(ngModel)]="editableLabels[idx]"
                                    name="tag{{ idx }}" placeholder="Label text" />
                                <button class="btn btn-outline-danger" type="button" (click)="removeMetaLabel(idx)">
                                    <i class="fa-solid fa-times"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="chart-data-row">
                    <label class="form-label d-flex align-items-center mb-2">
                        <i class="fa-solid fa-eye mr-2"></i>
                        Filtered Data (latest 6 rows displayed on chart)
                    </label>
                    <textarea class="form-control chart-data-textarea" rows="5" [value]="editableFilteredDataRaw" readonly
                        name="chartFilteredRaw"
                        placeholder="Jan-2024 35 20&#10;Feb-2024 42 24"></textarea>
                </div> -->
                <div class="chart-data-row">
                    <label class="form-label d-flex align-items-center mb-2">
                        <i class="fa-solid fa-pen-to-square mr-2"></i>
                        Data Rows
                    </label>
                    <textarea class="form-control chart-data-textarea" rows="8" [(ngModel)]="editableDataRaw"
                        name="chartDataRaw"
                        placeholder="Jan-2024 35 20&#10;Feb-2024 42 24&#10;Mar-2024 50 26"></textarea>
                    <small class="text-muted d-block mt-1">Format: month value1 value2 ... (space separated). One row
                        per
                        line.</small>
                </div>
                <div class="chart-data-hint">
                    <i class="fa-solid fa-lightbulb mr-2"></i>
                    Each new line is a data row → month value1 value2 ... (space separated).
                </div>
            </div>
        </div>
        <div class="show-booking-modal__footer">
            <button type="button" class="btn btn-outline-secondary" (click)="closeCreateDataModal()">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="saveChartData()">Save Data</button>
        </div>
    </div>
</ng-template>